import { useStore } from '../store/useStore.js';

function Icon({ name, size = 18 }: { name: string; size?: number }) {
  return <span className="material-symbols-outlined" style={{ fontSize: size }}>{name}</span>;
}

export function Sidebar() {
  const addNode = useStore((s) => s.addNode);
  const physicsEnabled = useStore((s) => s.physicsEnabled);
  const togglePhysics = useStore((s) => s.togglePhysics);
  const snapToGrid = useStore((s) => s.snapToGrid);

  function handleAdd() {
    const state = useStore.getState();
    const cam = state.cam;
    addNode({
      label: 'Nova Ideia', type: 'idea', category: 'idea', icon: 'lightbulb',
      x: -cam.x + Math.random() * 200 - 100,
      y: -cam.y + Math.random() * 200 - 100,
      size: 22,
    });
  }

  return (
    <aside className="syn-sidebar">
      <button className="syn-sb-btn primary" onClick={handleAdd} title="Criar nó (N)">
        <Icon name="add" size={20} />
        <span className="syn-tip">
          Criar nó <span className="tip-kbd">N</span>
        </span>
      </button>

      <div className="syn-sb-sep" />

      <button
        className="syn-sb-btn"
        title="Buscar"
        onClick={() => useStore.getState().setCmdPaletteOpen(true)}
      >
        <Icon name="search" size={18} />
        <span className="syn-tip">
          Buscar <span className="tip-kbd">⌘K</span>
        </span>
      </button>

      <button
        className={'syn-sb-btn' + (physicsEnabled ? ' is-active' : '')}
        onClick={() => togglePhysics()}
        title="Física"
      >
        <Icon name={physicsEnabled ? 'ac_unit' : 'play_arrow'} size={18} />
        <span className="syn-tip">
          {physicsEnabled ? 'Congelar física' : 'Ativar física'} <span className="tip-kbd">P</span>
        </span>
      </button>

      <button
        className={'syn-sb-btn' + (snapToGrid ? ' is-active' : '')}
        onClick={useStore.getState().toggleSnapToGrid}
        title="Snap to grid"
      >
        <Icon name="grid_4x4" size={18} />
        <span className="syn-tip">
          Snap-to-grid <span className="tip-kbd">⇧G</span>
        </span>
      </button>

      <div className="syn-sb-sep" />

      <button
        data-focus-audio-trigger
        className={'syn-sb-btn' + (useStore((s) => s.focusAudioOpen) ? ' is-active' : '')}
        onClick={() => {
          const state = useStore.getState();
          state.setFocusAudioOpen(!state.focusAudioOpen);
        }}
        title="Sons de Foco"
      >
        <Icon name="headphones" size={18} />
        <span className="syn-tip">Sons de Foco</span>
      </button>

      <button
        className={'syn-sb-btn' + (useStore((s) => s.chatOpen) ? ' is-active' : '')}
        onClick={() => {
          const state = useStore.getState();
          state.setChatOpen(!state.chatOpen);
        }}
        title="Neurology IA"
      >
        <Icon name="neurology" size={18} />
        <span className="syn-tip">Neurology IA</span>
      </button>

      <button
        className={'syn-sb-btn' + (useStore((s) => s.assistantOpen) ? ' is-active' : '')}
        onClick={() => {
          const state = useStore.getState();
          state.setAssistantOpen(!state.assistantOpen);
        }}
        title="Assistente (voz)"
      >
        <Icon name="graphic_eq" size={18} />
        <span className="syn-tip">Assistente</span>
      </button>
    </aside>
  );
}
